import { useEffect, useRef, useState } from 'react';
import { videoFirstFrameSource } from '../mediaPreview';

export default function CanvasVideoCover({ video, onError }) {
  const rootRef = useRef(null);
  const [visible, setVisible] = useState(typeof IntersectionObserver === 'undefined');
  const [posterFailed, setPosterFailed] = useState(false);
  const [ready, setReady] = useState(false);
  const poster = video.poster_url || video.thumbnail_url || video.cover_url;
  const showPoster = Boolean(poster && !posterFailed);

  useEffect(() => {
    if (visible) return undefined;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setVisible(true);
        observer.disconnect();
      }
    }, { rootMargin: '160px' });
    observer.observe(rootRef.current);
    return () => observer.disconnect();
  }, [visible]);

  useEffect(() => {
    if (!visible || ready) return undefined;
    const timer = window.setTimeout(() => {
      if (showPoster) setPosterFailed(true);
      else onError();
    }, 10000);
    return () => window.clearTimeout(timer);
  }, [visible, ready, showPoster, onError]);

  return (
    <div className={`canvas-video-cover${ready ? ' is-ready' : ''}`} ref={rootRef}>
      {!ready && <span className="canvas-video-cover__loading">正在加载封面</span>}
      {visible && (showPoster ? (
        <img src={poster} alt="" decoding="async" draggable={false} onLoad={() => setReady(true)} onError={() => setPosterFailed(true)} />
      ) : (
        <video
          src={videoFirstFrameSource(video.url)}
          muted
          playsInline
          preload="metadata"
          tabIndex={-1}
          aria-hidden="true"
          draggable={false}
          onLoadedData={() => setReady(true)}
          onSeeked={() => setReady(true)}
          onError={onError}
        />
      ))}
    </div>
  );
}
